<script>
  /**
   * Specify the pictogram title.
   * @type {string}
   */
  export let title = undefined;

  $: labelled =  $$props["aria-label"] || $$props["aria-labelledby"] || $$props["title"];
  $: attributes = {
    "aria-hidden": labelled ? undefined : true,
    role: labelled ? "img" : undefined,
    focusable: Number($$props["tabindex"]) === 0  ? true : undefined,
  };
</script>

<svg
  preserveAspectRatio="xMidYMid meet"
  xmlns="http://www.w3.org/2000/svg"
  viewBox="0 0 32 32"
  width="64"
  height="64"
  fill="currentColor"
  {title}
  {...attributes}
  {...$$restProps}>
  <path d="M16,31.36C7.53,31.36,0.64,24.47,0.64,16	c0-5.103,2.501-9.632,6.342-12.427c0.486-0.388,1.015-0.727,1.576-1.007C10.764,1.339,13.302,0.64,16,0.64	c8.47,0,15.36,6.89,15.36,15.36S24.47,31.36,16,31.36z M4.244,7.284C2.433,9.721,1.36,12.738,1.36,16	c0,8.072,6.567,14.64,14.64,14.64c2.436,0,4.734-0.598,6.757-1.654l-6.143-10.64c-1.23,0.647-2.63,1.015-4.114,1.015	c-4.885,0-8.86-3.975-8.86-8.86C3.64,9.366,3.854,8.282,4.244,7.284z M17.237,17.984l6.149,10.651	C27.723,26.092,30.64,21.38,30.64,16c0-8.073-6.567-14.64-14.64-14.64c-1.008,0-1.992,0.103-2.943,0.297	c3.642,0.227,6.695,2.665,7.83,5.983H24v0.72h-2.901c0.171,0.686,0.262,1.402,0.262,2.14c0,1.105-0.204,2.164-0.575,3.14H24v0.72	h-3.525C19.751,15.848,18.624,17.104,17.237,17.984z M7.418,4.146C5.555,5.639,4.36,7.933,4.36,10.5c0,4.488,3.652,8.14,8.14,8.14	c3.093,0,5.788-1.733,7.165-4.28H10v-0.72h10.01c0.3-0.714,0.501-1.48,0.585-2.28H8v-0.72h12.639	c0.001-0.047,0.001-0.093,0.001-0.14c0-0.74-0.099-1.458-0.285-2.14H10V7.64h10.121c-1.16-3.082-4.139-5.28-7.621-5.28	c-1.294,0-2.52,0.304-3.607,0.844C8.382,3.489,7.889,3.804,7.418,4.146z"></path>
</svg>